module.exports = __webpack_public_path__ + "static/img/service.be958ecd.png";